import React, { useEffect } from 'react';
import penguinIceCreamError from 'assets/icons/penguin-ice-cream-error.svg';
import { formatText } from 'core/i18n';
import { recordEventError } from 'utilities/uTagging';
import { HtmlText } from 'core/i18n';

export const MessageModal = ({
    message,
    onAccept,
    title,
    videoType,
    statusNumber,
    statusCode,
    showImage = true,
    showsSecondaryButton = false,
    onCancel,
    children,
    showFooter = true,
}) => {
    useEffect(() => {
        recordEventError(
            `interaccion en ${videoType}`,
            'modal algo salio mal',
            'vista',
            statusCode,
            message,
            statusNumber
        );
    }, []);

    const handleOnAccept = () => {
        recordEventError(
            `interaccion en ${videoType}`,
            'modal algo salio mal',
            'entendido',
            statusCode,
            message,
            statusNumber
        );

        onAccept?.();
    };

    return (
        <div className="videoScreen-container">
            <div className="videoScreen-container-content">
                <div className="videoScreen-container-content-title">
                    <h4>{title}</h4>
                </div>
                {showImage && (
                    <img
                        src={penguinIceCreamError}
                        alt="penguin-error"
                        className="videoScreen-container-content-image"
                    />
                )}
                <div className="videoScreen-container-content-message">{HtmlText(message)}</div>

                {children}
            </div>

            {showFooter && (
                <div className={`video-screen__modal-buttons ${showsSecondaryButton && 'two-buttons-footer'}`}>
                    {showsSecondaryButton && (
                        <button className="form__button form__button-clean" onClick={onCancel}>
                            {formatText('button-leave')}
                        </button>
                    )}
                    <button className="form__button form__button-secondary error_button" onClick={handleOnAccept}>
                        {formatText('button-understood')}
                    </button>
                </div>
            )}
        </div>
    );
};
